<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import { truthy } from './util'

const props = defineProps<{
  item: ParsedContent
}>()

const subtitle = computed(() => {
  const doc = props.item
  if (!doc) return null
  const category = doc.category || []
  if (category.includes('epic boon')) {
    const prereq = ['Level 19+', doc.prereq].filter(truthy).join(', ')
    return `Epic Boon feat (Prerequisite: ${prereq})`
  }
  if (category.includes('fighting style')) {
    const prereq = ['Fighting Style feature', doc.prereq].filter(truthy).join(', ')
    return `Fighting Style feat (Prerequisite: ${prereq})`
  }
  const prereq = doc.prereq ? ` (Prerequisite: ${doc.prereq})` : ''
  return `${category.includes('origin') ? 'Origin' : 'General'} feat${prereq}`
})
</script>

<template>
  <p class="subtitle subtitle--feat">
    {{ subtitle }}
  </p>
</template>

<style lang="postcss" scoped></style>
